
<template>
    <div class="columns is-centered">
        <div class="column is-5">
            <h2 class="is-size-3 mb-5">Logga in</h2>
            <form v-if="!success" v-on:submit.prevent="submitForm">
                <div class="field">
                    <label class="label">E-post</label>
                    <div class="control has-icons-left has-icons-right">
                        <input v-model="form.email" v-on:focus="reset" class="input" v-bind:class="{'is-danger': error}" type="email" placeholder="name@example.com">
                        <span class="icon is-small is-left">
                            <i class="fas fa-envelope"></i>
                        </span>
                        <span v-if="error" class="icon is-small is-right">
                            <i class="fas fa-exclamation-triangle"></i>
                        </span>
                    </div>
                    <p v-if="error" class="help is-danger">{{error}}</p>
                </div>
                <div class="field">
                    <div class="control" v-bind:class="{'is-loading': loading }">
                        <button class="button is-link is-fullwidth" v-bind:disabled="submitted">Fortsätt</button>
                    </div>
                </div>
            </form>
            <div v-if="success">
                Ett bekräftelsemail har skickats till adressen du angav. Klicka på länken i mailet för att logga in.
            </div>
        </div>
    </div>
</template> 

<script>
export default {
    name: 'LoginForm',
    data(){
        return{
            form: {
                email: '',
            },
            success: false,
            submitted: false,
            loading: false,
            error: ""
        }
    },
    methods:{
        reset(){
            if(this.submitted) {
                this.error = "";
                this.loading = false;
                this.submitted = false;
            }
        },
        submitForm(){
            if(this.form.email) {
                this.submitted = true;
                this.loading = true;
                this.$store.dispatch("login", this.form)
                    .then((res) => { // eslint-disable-line no-unused-vars
                        //console.log(res); // eslint-disable-line no-console
                        this.success = true;
                    })
                    .catch((error) => {
                        // error.response.status Check status code
                        //console.log(error.response); // eslint-disable-line no-console
                        this.error = error.response.data.error;
                    }).finally(() => {
                        //Perform action in always
                        this.loading = false;
                    });
            }
        }
    }
}
</script>